import { NEXT_PUBLIC_NODE_ENV, NEXT_PUBLIC_MOM_BABY_BASE_PATH } from "@/libs/constants/auth";

const basePath = NEXT_PUBLIC_NODE_ENV !== "development" ? NEXT_PUBLIC_MOM_BABY_BASE_PATH : "";

export type resourcesType = "video" | "articles";

const routes = {
  home: `${basePath}/`,
  login: `${basePath}/login`,
  communityListing: `${basePath}/community`,
  toolsListing: (category?: string): string => `${basePath}/tools-and-calculators${category ? `/${category}` : ""}`,
  tool: (toolID: string | number): string => `${basePath}/t/${toolID}`,
  toolResult: (toolID: string | number): string => `${basePath}/t/${toolID}/result`,
  resourcesListing: (filter?: [string, string[]], resourceType?: resourcesType, page?: number) =>
    `${basePath}/resources${filter?.length ? `-${filter?.[0]}/${filter?.[1]?.[0]}` : ""}${resourceType ? `/${resourceType}` : ""}${page > 1 ? `/${page}` : ""}`,
  community: (communityID: string | number): string => `${basePath}/community/${communityID}`,
  pillar: (pillarID: string | number): string => `${basePath}/p/${pillarID}`,
  cluster: (clusterID: string | number): string => `${basePath}/cl/${clusterID}`,
  category: (categoryID: string | number): string => `${basePath}/c/${categoryID}`,
  article: (articleID: string | number): string => `${basePath}/a/${articleID}`,
  video: (videoId: string): string => `${basePath}/v/${videoId}`,
  savedCollections: (category?: string): string => `${basePath}/profile/saved${category ? `/${category}` : ""}`,
};

export { basePath as routeBasePath };

export default routes;
